"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var initialScale = [0, 8, 16, 32, 48, 64, 96];

exports.default = initialScale;